/* eslint-disable no-unused-vars */
import React from 'react'
import { InputNumber } from 'antd'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import StockInputIconButton from './StockInputIconButton/StockInputIconButton'
import styles from './CustomStockInput.module.scss'

interface CustomStockInputProps {
  name: string
  suffix: string
  value: number
  setValue: (value: number) => void
}

const CustomStockInput: React.FC<CustomStockInputProps> = (props) => {
  const { name, suffix, value, setValue } = props

  const handleClick = (method: string) => () => {
    if (method === '+') {
      setValue(value + 1)
    } else if (method === '-' && value < 1) {
      setValue(0)
    } else if (method === '-') {
      setValue(value - 1)
    }
  }

  const handleChange = (v: number) => {
    const newValue = v === null ? 0 : v
    setValue(newValue)
  }

  return (
    <>
      <InputNumber
        name={name}
        className={styles['input-number']}
        addonAfter={<StockInputIconButton icon={<PlusOutlined />} onClicHandler={handleClick('+')} />}
        addonBefore={<StockInputIconButton icon={<MinusOutlined />} onClicHandler={handleClick('-')} />}
        value={value}
        placeholder={suffix}
        onChange={handleChange}
      />
    </>
  )
}

export default CustomStockInput
